import BaseInvoker from "../../BaseInvoker";


const baseUrl = "api/mobility/"
const baseInvoker = new BaseInvoker()

export type PatchBookingBody = {
    driverId: number
    bookingStartDateTime: string
}

interface PatchTransferBookingsProps {
    bookingId: number
    body: PatchBookingBody
    callback: Function
    callerror: Function
}

export const patchTransferBooking = ({bookingId, body, callback, callerror} : PatchTransferBookingsProps): Promise<void> => {
    return new Promise((resolve, reject) => {
        baseInvoker.patch(
            `${baseUrl}transfer-bookings/${bookingId}`,
            body,
            () => {
                callback();
                resolve();
            },
            (error: Error) => {
                callerror(error);
                reject(error);
            }
        );
    });
}

